import '@babel/polyfill'
import Vue from 'vue'
import './plugins/fontawesome'
import './plugins/axios'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VModal from 'vue-js-modal'
import axios from 'axios'
import LogRocket from 'logrocket';
LogRocket.init('spac/itm_student');

Vue.prototype.$Axios = axios;
Vue.use(VModal, { dynamic: true })
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
